import { createListenerMiddleware } from '@reduxjs/toolkit';
import { communityApi } from 'community/api';
import { setActiveCommunityId } from 'community/state/communitySlice';
import { addAppSuccessMessage } from 'modules/alerts/state';
import type { RootState } from 'store';
import { handleQueryError } from 'store/utils';
import { userApi } from 'user/api';

import { organizationApi } from './organizationApi';

export const organizationApiListener = createListenerMiddleware<RootState>();

organizationApiListener.startListening({
  matcher: organizationApi.endpoints.updateCommunity.matchFulfilled,
  effect: (_args, { dispatch }) => {
    dispatch(communityApi.util.invalidateTags(['MY_COMMUNITIES']));
  },
});

organizationApiListener.startListening({
  matcher: organizationApi.endpoints.joinOrganization.matchFulfilled,
  effect: (_args, { dispatch }) => {
    dispatch(addAppSuccessMessage('Successfully joined organization'));
    dispatch(userApi.util.invalidateTags(['ACCOUNT']));
  },
});

organizationApiListener.startListening({
  matcher: organizationApi.endpoints.joinOrganization.matchRejected,
  effect: ({ payload, type }, { dispatch }) => {
    handleQueryError(payload, dispatch, type, 'Unable to join organization');
  },
});

organizationApiListener.startListening({
  matcher: organizationApi.endpoints.removeOrganizationMember.matchFulfilled,
  effect: (_args, { dispatch }) => {
    dispatch(addAppSuccessMessage('Organization member removed successfully'));
  },
});

organizationApiListener.startListening({
  matcher: organizationApi.endpoints.removeOrganizationMember.matchRejected,
  effect: ({ payload, type }, { dispatch }) => {
    handleQueryError(payload, dispatch, type, 'Unable to remove organization member');
  },
});

organizationApiListener.startListening({
  matcher: organizationApi.endpoints.inviteOrganizationMember.matchFulfilled,
  effect: (_args, { dispatch }) => {
    dispatch(addAppSuccessMessage('Invitation has been sent'));
  },
});

organizationApiListener.startListening({
  matcher: organizationApi.endpoints.inviteOrganizationMember.matchRejected,
  effect: ({ payload, type }, { dispatch }) => {
    handleQueryError(payload, dispatch, type, 'Unable to invite member to organization');
  },
});

organizationApiListener.startListening({
  matcher: organizationApi.endpoints.updateOrganizationMemberAccess.matchFulfilled,
  effect: (_args, { dispatch }) => {
    dispatch(addAppSuccessMessage('Member access updated'));
  },
});

organizationApiListener.startListening({
  matcher: organizationApi.endpoints.updateOrganizationMemberAccess.matchRejected,
  effect: ({ payload, type }, { dispatch }) => {
    handleQueryError(payload, dispatch, type, 'Unable to update member access');
  },
});

organizationApiListener.startListening({
  matcher: organizationApi.endpoints.transferCommunity.matchFulfilled,
  effect: (_args, { dispatch }) => {
    dispatch(addAppSuccessMessage('Community has been successfully transferred'));
  },
});

organizationApiListener.startListening({
  matcher: organizationApi.endpoints.transferCommunity.matchRejected,
  effect: ({ payload, type }, { dispatch }) => {
    handleQueryError(payload, dispatch, type, 'Transfer error occurred. Please check the email address or try again.');
  },
});

organizationApiListener.startListening({
  matcher: organizationApi.endpoints.createCommunity.matchFulfilled,
  effect: ({ payload: { id } }, { dispatch }) => {
    dispatch(communityApi.util.invalidateTags(['MY_COMMUNITIES']));
    dispatch(setActiveCommunityId(id));
  },
});

organizationApiListener.startListening({
  matcher: organizationApi.endpoints.createCommunity.matchRejected,
  effect: ({ payload, type }, { dispatch }) => {
    handleQueryError(payload, dispatch, type, 'Unable to create Community');
  },
});

organizationApiListener.startListening({
  matcher: organizationApi.endpoints.updateCommunity.matchFulfilled,
  effect: (_args, { dispatch }) => {
    dispatch(addAppSuccessMessage('Community details updated successfully'));
  },
});

organizationApiListener.startListening({
  matcher: organizationApi.endpoints.updateCommunity.matchRejected,
  effect: ({ payload, type }, { dispatch }) => {
    handleQueryError(payload, dispatch, type, 'Unable to update Community');
  },
});

organizationApiListener.startListening({
  matcher: organizationApi.endpoints.uploadCommunityLogo.matchRejected,
  effect: ({ payload, type }, { dispatch }) => {
    handleQueryError(payload, dispatch, type, 'Unable to upload Community logo');
  },
});

organizationApiListener.startListening({
  matcher: organizationApi.endpoints.deleteCommunity.matchFulfilled,
  effect: (_args, { dispatch }) => {
    dispatch(addAppSuccessMessage('Community successfully deleted'));
  },
});

organizationApiListener.startListening({
  matcher: organizationApi.endpoints.deleteCommunity.matchRejected,
  effect: ({ payload, type }, { dispatch }) => {
    handleQueryError(payload, dispatch, type, 'Unable to delete Community');
  },
});

organizationApiListener.startListening({
  matcher: organizationApi.endpoints.removeCommunityMember.matchFulfilled,
  effect: (_args, { dispatch }) => {
    dispatch(addAppSuccessMessage('Community member removed successfully'));
  },
});

organizationApiListener.startListening({
  matcher: organizationApi.endpoints.removeCommunityMember.matchRejected,
  effect: ({ payload, type }, { dispatch }) => {
    handleQueryError(payload, dispatch, type, 'Unable to remove Community Member');
  },
});

organizationApiListener.startListening({
  matcher: organizationApi.endpoints.inviteGuestsToCommunity.matchFulfilled,
  effect: (_args, { dispatch }) => {
    dispatch(addAppSuccessMessage('Invitation has been sent'));
  },
});

organizationApiListener.startListening({
  matcher: organizationApi.endpoints.inviteGuestsToCommunity.matchRejected,
  effect: ({ payload, type }, { dispatch }) => {
    handleQueryError(payload, dispatch, type, 'Unable to invite guests to Community');
  },
});
